import * as React from 'react'
import { ITripHistoryObject } from '../../types'
import Badge from '../ui/Badge'
import Rating from '../ui/Ratings'
import TripHistoryDetailSection from './TripHistoryDetailSection'

interface ITripHistoryFeedbackDetailsProps {
  trip: ITripHistoryObject
}

const TripHistoryFeedbackDetails = (props: ITripHistoryFeedbackDetailsProps) => {
  const trip = props.trip
  if (!trip.feedback) {
    return null
  }
  return (
    <TripHistoryDetailSection
      title={
        <React.Fragment>
          Feedback <span className='h6 font-grey'>from Dispatcher</span>
        </React.Fragment>
      }
    >
      <div className='mb1'>
        <Rating rating={trip.feedback.rating} />
      </div>
      <div className='h6 mb1'>{trip.feedback.message}</div>
      <div className='h6 font-grey mb1'>Tags</div>
      <div>
        {trip.feedback.tags.map((tag: string) => (
          <Badge key={`th_tah_${tag}`} label={tag} />
        ))}
      </div>
    </TripHistoryDetailSection>
  )
}

export default TripHistoryFeedbackDetails



// WEBPACK FOOTER //
// ./src/components/trips/TripHistoryFeedbackDetails.tsx